import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "path-presenter-wrapper" }

import AttributeGroupSelectionModal from "@common/components/MultiLevelNavigation/AttributeGroupSelectionModal.vue";
import PathPresenter from "@common/components/PathPresenter.vue";
import { useContentLanguages } from "@common/composable/useMetaDataStore";
import { BasicSelectionModel } from "@medapro-types/AdvancedSearch/components/QueryBuilder";
import { AttributeGroup } from "@medapro-types/common/common";
import { Branch, MultiLevelNavigationConfirmModel } from "@medapro-types/common/components/MultiLevelNavigation";
import { PathPresentedDataModel } from "@medapro-types/common/components/PathPresenter";
import attributeGroupsApi from "@services/attributeGroups.js";
import _ from "lodash";
import { Ref, computed, inject, nextTick, onMounted, reactive } from "vue";

//#region General
type ViewModel = { selectedPath: BasicSelectionModel[] };

export default /*#__PURE__*/_defineComponent({
  __name: 'AttributeGroupRule',
  props: {
    value: {}
  },
  emits: ["input", "deleteRule"],
  setup(__props: any, { emit: emits }) {

const props = __props;



//#endregion

//#region Store
const { primaryLanguageCode } = useContentLanguages();

//#endregion

//#region Inject
const isBusy = inject<Ref<boolean>>("advancedSearchIsBusy");
//#endregion

//#region Viewmodel
const vm = reactive<ViewModel>({ selectedPath: [] });

const modals = reactive({ open: false });
//#endregion

//#region Busy
const setBusyState = (busyValue: boolean) => {
  if (isBusy) {
    isBusy.value = busyValue;
  }
};
//#endregion

const localModel = computed({
  get() {
    return props.value;
  },
  set(nv) {
    emits("input", nv);
  }
});

//#region SelectedPath
const selectedPath = computed<Branch[]>(() =>
  vm.selectedPath?.filter((x) => x.id != localModel.value).map((x, index) => ({ id: x.id, depth: index, name: x.name, parentId: null }))
);
//#endregion

//#region EventHandler
const onHideHandler = () => {
  nextTick(() => {
    if (_.isEmpty(localModel.value)) emits("deleteRule");
  });
};

const onConfirm = async (data: MultiLevelNavigationConfirmModel) => {
  if (data.selection && data.selection.id) {
    localModel.value = data.selection.id;
    await fetchAndSetPath(data.selection.id);
  }
};

const fetchAndSetPath = async (id: string) => {
  setBusyState(true);
  const fetchedPath: AttributeGroup[] = await attributeGroupsApi.getPath(primaryLanguageCode.value, id);
  const mappedFetchedPath: PathPresentedDataModel[] = fetchedPath.map((x) => ({ id: x.attributeGroupId, name: x.name }));
  const root = _.first(mappedFetchedPath);
  if (root) root.icon = "Home";
  vm.selectedPath = mappedFetchedPath;
  setBusyState(false);
};
//#endregion

//#region LifeCycle
onMounted(async () => {
  if (!props.value) {
    modals.open = true;
  } else {
    await fetchAndSetPath(props.value);
  }
});
//#endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "attribute-group-rule",
    onClick: _cache[2] || (_cache[2] = ($event: any) => (modals.open = true))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(PathPresenter, {
        modelValue: vm.selectedPath,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vm.selectedPath) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(AttributeGroupSelectionModal, {
      modelValue: modals.open,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modals.open) = $event)),
      onConfirm: onConfirm,
      onHide: onHideHandler,
      "selected-entry-id": localModel.value,
      "selected-path": selectedPath.value
    }, null, 8, ["modelValue", "selected-entry-id", "selected-path"])
  ]))
}
}

})